import React from 'react'
import { FormattedMessage } from 'react-intl'
import { generateValidPickupTimes, getStoreSchedule } from '../../utils/time'

export function generateTimeOptions(store) {
  const storeSchedule = getStoreSchedule(store.opening_hours)
  const timeSelection = generateValidPickupTimes(
    storeSchedule,
    Object.keys(storeSchedule)[0],
    store.min_order_time
  )

  const hours = []
  const minutes = []
  const minHour = timeSelection[0].value.get('hours')
  const maxHour = timeSelection[timeSelection.length - 1].value.get('hours')

  // eslint-disable-next-line no-plusplus
  for (let i = minHour - 1; i <= maxHour + 1; i++) {
    if (i >= 0) {
      const label = i < 10 ? `0${i}` : i.toString()
      hours.push(label)
    }
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < 60; i++) {
    const label = i < 10 ? `0${i}` : i.toString()
    minutes.push(label)
  }

  return { hour: hours, minute: minutes }
}

export function generateQuickSelectorOptions(store, order) {
  const FIFTEEEN_MINS_IN_SECS = 900
  const quickSelector = {
    IN_X_MINS: store.min_order_time <= FIFTEEEN_MINS_IN_SECS ? 15 : (store.min_order_time / 60) + 15,
    IN_XX_MINS: store.min_order_time <= FIFTEEEN_MINS_IN_SECS ? 30 : (store.min_order_time / 60) + 30,
  }

  let options = []
  if (order) {
    options = [
      { label: '+ 10 min', value: 10 },
      { label: '+ 20 min', value: 20 },
      { label: '+ 30 min', value: 30 },
    ]
  } else {
    options = [
      { label: <FormattedMessage id="components.TimePicker.Asap" />, value: 0 },
      { label: `in ${quickSelector.IN_X_MINS} min`, value: quickSelector.IN_X_MINS },
      { label: `in ${quickSelector.IN_XX_MINS} min`, value: quickSelector.IN_XX_MINS },
    ]
  }

  return options
}
